import styled from 'styled-components'

export {
  Container,
  PreviewContent,
} from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/previewStyles'

export const SelectorContainer = styled.div`
  border: ${props => props.theme.stroke.emphasis} solid transparent;
  border-radius: ${props => props.theme.primitives.radius.radius4};
  display: flex;
  flex-direction: column;
`

export const LineItemContainer = styled.div`
  padding: ${props => props.theme.spacing.sp16};
`

export const IsReturnableMessage = styled.div`
  margin-bottom: ${props => props.theme.spacing.sp8};
  display: flex;
  flex-direction: column;
`

export const ErrorTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  margin-bottom: ${props => props.theme.spacing.sp4};
`

export const ProductRow = styled.div`
  display: flex;
  flex-direction: row;
`

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: calc(100% - 108px);
  padding-right: ${props => props.theme.spacing.sp8};
  padding-bottom: ${props => props.theme.spacing.sp4};
  padding-left: ${props => props.theme.spacing.sp16};
  gap: ${props => props.theme.spacing.sp4};
`
